import { Button, Chip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

export type ChipSpecs<TField extends string = string> = {
  field: TField; // fieldName (key)
  title?: string;
  label: string;
  keyOverride?: string;
  currency?: string;
};

type FilterChipsProps<TField extends string = string> = {
  chips: Array<ChipSpecs<TField>>;
  onRemove?: (field: TField) => void;
  onClearAll?: () => void;
};
export function AdvancedSearchChipSummary<TField extends string = string>({ chips, onRemove, onClearAll }: FilterChipsProps<TField>) {
  const { t } = useTranslation();
  if (!chips?.length) return null;

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
      {chips.map(({ field, title, label, keyOverride, currency }) => (
        <Chip
          key={keyOverride ?? field}
          onDelete={onRemove ? () => onRemove(field) : undefined}
          color='primary'
          label={
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, color: 'white', alignItems: 'center', mr: 1, pl: 0.5 }}>
              {title && (
                <Typography variant='body2' sx={{ fontWeight: 100 }}>
                  {title}
                </Typography>
              )}
              <Typography variant='body2' sx={{ fontWeight: 600 }}>
                {label} {currency && currency}
              </Typography>
            </Box>
          }
        />
      ))}
      {onClearAll && (
        <Box>
          <Button variant='text' onClick={() => onClearAll()}>
            {t('common:button.resetAll')}
          </Button>
        </Box>
      )}
    </Box>
  );
}
